import React from "react";
import { Container, Col, Row, Form } from "react-bootstrap";
import { connectRange, connectMenu, SortBy, connectSearchBox } from 'react-instantsearch-dom';
import SearchInputBox from "./SearchInputBox"
import './Filter.scss';
import _ from "lodash";
import Select from 'react-select';


const styles = {
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
        return {
            ...styles,
        };
    },
    control: styles => ({
        ...styles,
        backgroundColor: null,
        border: 0,
        outline: 0,
        boxShadow: 'none',
        height: "100%",
        padding: 0
    }),
    placeholder: (defaultStyles) => {
        return {
            ...defaultStyles,
        }
    },
    dropdownIndicator: (defaultStyles) => {
        return {
            ...defaultStyles,
            display: "none"
        }
    },
    valueContainer: (styles) => ({
        ...styles,
        padding: 0
    }),
    indicatorSeparator: () => null,
}

const SearchBox = connectSearchBox(({ currentRefinement, refine }) => {
    return (
        <div className="dropdown-exp d-lg-block">
            <Form.Group>
                <Form.Control type="text" className="postcode_input" placeholder="Search here"
                    onChange={event => refine(event.currentTarget.value.replace(/ /g, "-").toLowerCase())}
                    value={currentRefinement.replace(/-/g, ' ')}
                />
                <i className="icon-search" />
            </Form.Group>
        </div>
    )
})

//Radius List
const radiusList = [
    // { value: null, label: "Radius" }, 
    { value: 3, label: "3 miles" },
    { value: 4, label: "4 miles" },
    { value: 6, label: "6 miles" },
    { value: 8, label: "8 miles" },
    { value: 10, label: "10+ miles" }
  ]

// Property Min price
const priceminRangeSale = [
    {
        value: "",
        label: "No Min",
    },
    {
        value: "100000",
        label: "£100,000",
    },
    {
        value: "500000",
        label: "£500,000",
    },
    {
        value: "600000",
        label: "£600,000",
    },
    {
        value: "700000",
        label: "£700,000",
    },
    {
        value: "800000",
        label: "£800,000",
    },
    {
        value: "900000",
        label: "£900,000",
    },
    {
        value: "1000000",
        label: "£1,000,000",
    },
    {
        value: "1250000",
        label: "£1,250,000",
    },
    {
        value: "1500000",
        label: "£1,500,000",
    },
    {
        value: "1750000",
        label: "£1,750,000",
    },
    {
        value: "2000000",
        label: "£2,000,000",
    },
    {
        value: "2500000",
        label: "£2,500,000",
    },
    {
        value: "3000000",
        label: "£3,000,000",
    },
    {
        value: "3500000",
        label: "£3,500,000",
    },
    {
        value: "4000000",
        label: "£4,000,000",
    },
    {
        value: "5000000",
        label: "£5,000,000",
    },
    {
        value: "7500000",
        label: "£7,500,000",
    },
    {
        value: "10000000",
        label: "£10,000,000",
    },
]

const priceminRangeRent = [
    {
        value: "",
        label: "No Min",
    },
    {
        value: "1000",
        label: "£1000 PCM",
    },
    {
        value: "2000",
        label: "£2000 PCM",
    },
    {
        value: "3000",
        label: "£3000 PCM",
    },
    {
        value: "4000",
        label: "£4000 PCM",
    },
    {
        value: "5000",
        label: "£5000 PCM",
    },
    {
        value: "6000",
        label: "£6000 PCM",
    },
    {
        value: "7000",
        label: "£7000 PCM",
    },
    {
        value: "8000",
        label: "£8000 PCM",
    },
    {
        value: "9000",
        label: "£9000 PCM",
    },
    {
        value: "10000",
        label: "£10000 PCM",
    },
    {
        value: "11000",
        label: "£11000 PCM",
    },
    {
        value: "12000",
        label: "£12000 PCM",
    },
    {
        value: "13000",
        label: "£13000 PCM",
    },
    {
        value: "14000",
        label: "£14000 PCM",
    },
    {
        value: "15000",
        label: "£15000 PCM",
    },
    {
        value: "16000",
        label: "£16000 PCM",
    },
    {
        value: "17000",
        label: "£17000 PCM",
    },
    {
        value: "18000",
        label: "£18000 PCM",
    },
    {
        value: "19000",
        label: "£19000 PCM",
    },
    {
        value: "20000",
        label: "£20000 PCM",
    }
]

const pricemaxRangeSale = [
    {
        value: "",
        label: "No Max",
    },
    {
        value: "500000",
        label: "£500,000",
    },
    {
        value: "600000",
        label: "£600,000",
    },
    {
        value: "700000",
        label: "£700,000",
    },
    {
        value: "800000",
        label: "£800,000",
    },
    {
        value: "900000",
        label: "£900,000",
    },
    {
        value: "1000000",
        label: "£1,000,000",
    },
    {
        value: "1250000",
        label: "£1,250,000",
    },
    {
        value: "1500000",
        label: "£1,500,000",
    },
    {
        value: "1750000",
        label: "£1,750,000",
    },
    {
        value: "2000000",
        label: "£2,000,000",
    },
    {
        value: "2500000",
        label: "£2,500,000",
    },
    {
        value: "3000000",
        label: "£3,000,000",
    },
    {
        value: "3500000",
        label: "£3,500,000",
    },
    {
        value: "4000000",
        label: "£4,000,000",
    },
    {
        value: "5000000",
        label: "£5,000,000",
    },
    {
        value: "7500000",
        label: "£7,500,000",
    },
    {
        value: "10000000",
        label: "£10,000,000",
    },
    {
        value: "15000000",
        label: "£15,000,000",
    },
    {
        value: "25000000",
        label: "£25,000,000",
    },
    {
        value: "50000000",
        label: "£50,000,000",
    }
]


const pricemaxRangeRent = [
    {
        value: "",
        label: "No Max",
    },
    {
        value: "3000",
        label: "£3000 PCM",
    },
    {
        value: "4000",
        label: "£4000 PCM",
    },
    {
        value: "5000",
        label: "£5000 PCM",
    },
    {
        value: "6000",
        label: "£6000 PCM",
    },
    {
        value: "7000",
        label: "£7000 PCM",
    },
    {
        value: "8000",
        label: "£8000 PCM",
    },
    {
        value: "9000",
        label: "£9000 PCM",
    },
    {
        value: "10000",
        label: "£10000 PCM",
    },
    {
        value: "11000",
        label: "£11000 PCM",
    },
    {
        value: "12000",
        label: "£12000 PCM",
    },
    {
        value: "13000",
        label: "£13000 PCM",
    },
    {
        value: "14000",
        label: "£14000 PCM",
    },
    {
        value: "15000",
        label: "£15000 PCM",
    },
    {
        value: "16000",
        label: "£16000 PCM",
    },
    {
        value: "17000",
        label: "£17000 PCM",
    },
    {
        value: "18000",
        label: "£18000 PCM",
    },
    {
        value: "19000",
        label: "£19000 PCM",
    },
    {
        value: "20000",
        label: "£20000 PCM",
    },
    {
        value: "25000",
        label: "£25000 PCM",
    },
    {
        value: "30000",
        label: "£30000 PCM",
    }
]




var minpriceval = minpriceval || ""
var maxpriceval = maxpriceval || ""


const minpriceSelectbox = ({ currentRefinement, refine, value, sales }) => {
    let selectedArr = sales ? priceminRangeSale : priceminRangeRent;
    let minPriceRange = selectedArr;
    if (currentRefinement.max !== undefined) {
        minPriceRange = selectedArr.filter(
            x => parseInt(x.value) < parseInt(currentRefinement.max) || x.value === ""
        )
    }
    return (
        <Select className="form-control"
            name="minprice"
            styles={styles}
            value={minPriceRange.find(obj => obj.value == currentRefinement.min) || minPriceRange.find(obj => obj.value == value)}
            options={minPriceRange}
            placeholder="Min Price"
            isSearchable={false}
            onChange={event => {
                minpriceval = event.value
                if (event.value === "") {
                    if (maxpriceval) {
                        refine({
                            max: maxpriceval,
                        })
                    } else {
                        refine({
                            min: event.value,
                            max: currentRefinement.max
                        })
                    }
                } else {
                    refine({
                        min: event.value,
                        max: maxpriceval || currentRefinement.max,
                    })
                }
            }}
        >
        </Select>
    )
}


const maxpriceSelectbox = ({ currentRefinement, refine, value, sales }) => {
    let selecedArr = sales ? pricemaxRangeSale : pricemaxRangeRent;
    let maxPriceRange = selecedArr.sort((a, b) => parseInt(b.value) - parseInt(a.value));
    let maxpricedisable = ""
    if (currentRefinement.min !== undefined) {
        maxPriceRange = selecedArr.filter(
            x => parseInt(x.value) > parseInt(currentRefinement.min) || x.value === ""
        )
    }
    if (currentRefinement.min == "10000000") {
        maxpricedisable = "disabled"
    }
    return (
        <Select className="form-control max"
            name="maxprice"
            disabled={maxpricedisable}
            styles={styles}
            value={maxPriceRange.find(obj => obj.value == currentRefinement.max) || maxPriceRange.find(obj => obj.value == value)}
            placeholder="Max Price"
            options={maxPriceRange}
            isSearchable={false}
            onChange={event => {
                maxpriceval = event.value
                if (event.value === "") {
                    if (minpriceval) {
                        refine({
                            min: minpriceval,
                        })
                    } else {
                        refine({
                            min: currentRefinement.min,
                            max: event.value
                        })
                    }
                } else {
                    refine({
                        min: minpriceval || currentRefinement.min,
                        max: event.value,
                    })
                }
            }}
        >
        </Select>
    )
}

// Property Bedrooms
const bedroomSelectboxoption = [
    {
        value: "",
        label: "Beds",
    },
    {
        value: "1",
        label: "1+",
    },
    {
        value: "2",
        label: "2+",
    },
    {
        value: "3",
        label: "3+",
    },
    {
        value: "4",
        label: "4+",
    },
    {
        value: "5",
        label: "5+",
    },
    {
        value: "6",
        label: "6+",
    },
    {
        value: "7",
        label: "7+",
    }
]
const bedroomSelectbox = ({ currentRefinement, refine, value }) => {
    return (
        <Select className="form-control bedroom"
            name="bedroom"
            value={bedroomSelectboxoption.find(obj => obj.value == value)}
            placeholder="Beds"
            options={bedroomSelectboxoption}
            styles={styles}
            isSearchable={false}
            onChange={event => {
                if (event.value === "") {
                    refine(event.value)
                } else {
                    refine({
                        min: event.value,
                    })
                }
            }}
        >
        </Select>
    )
}

// Property Type
const propertyTypeFilteroption = [
    {
        value: "",
        label: "All Properties",
    },
    {
        value: "apartment",
        label: "Flat/Apartment",
    },
    {
        value: "house",
        label: "House",
    },
    {
        value: "developmentplot",
        label: "Development Plot",
    },
    {
        value: "land",
        label: "Land",
    }
]
const propertyTypeFilter = ({ currentRefinement, refine, value }) => {
    return (
        <Select className="form-control bedroom"
            name="bedroom"
            value={propertyTypeFilteroption.find(obj => obj.value == value)}
            placeholder="All Properties"
            options={propertyTypeFilteroption}
            styles={styles}
            isSearchable={false}
            onChange={event => refine(event.value)}
        >
        </Select>
    )
}

// Office Type
const officeTypeFilteroption = [
    {
        value: "",
        label: "All offices",
    },
    {
        value: "beaconsfield",
        label: "Beaconsfield",
    },
    {
        value: "windsor",
        label: "Windsor",
    }
]
const officeTypeFilter = ({ currentRefinement, refine, value }) => {
    return (
        <Select className="form-control bedroom"
            name="bedroom"
            value={officeTypeFilteroption.find(obj => obj.value == value)}
            placeholder="All offices"
            options={officeTypeFilteroption}
            styles={styles}
            isSearchable={false}
            onChange={event => refine(event.value)}
        >
        </Select>
    )
}

const CustomminpriceSelectbox = connectRange(minpriceSelectbox);
const CustommaxpriceSelectbox = connectRange(maxpriceSelectbox);
const CustombedroomSelectbox = connectRange(bedroomSelectbox);
const CustomPropertyMenu = connectMenu(propertyTypeFilter);
const CustomOfficeMenu = connectMenu(officeTypeFilter);

const FilterPage = (props) => {
    const query = props.query;
    const min = props.min === "" ? undefined : parseInt(props.min);
    const max = props.max === "" ? undefined : parseInt(props.max);
    const bedrooms = props.bedrooms === "" ? undefined : parseInt(props.bedrooms);
    const building = props.building === "" ? undefined : props.building;
    const officeSlug = props.officeSlug === "" ? undefined : props.officeSlug;
    const radius = props.radius; 
    const radiusAvailable = props.radiusAvailable; 

    if (officeSlug?.length >= 0) {
        props.setbanner(officeSlug)
    } else {
        props.setbanner("")
    }




    return (
        <section className="filter">
            <Container className="filtercontainer">
                <Row>
                    <Col className="filter-fixed ">
                        <Form className="form-data">
                            <div className="search-box">
                                {/* <SearchBox defaultRefinement={query} showLoadingIndicator={false}/> */}
                                <SearchInputBox areaList={props.areaList} areaVal={props.searchVal.replace(/-/g, ' ')} value={props.searchVal} setSearchVal={props.setSearchVal} />
                            </div>
                            <div className="box-wrapper d-xl-flex">
                                <div className="select-boxes order-xl-1 sel-radius">
                                    <Select className="form-control radius"
                                        name="radius"
                                        styles={styles}
                                        value={radiusList.find(obj => obj.value == radius)}
                                        options={radiusList}
                                        placeholder="Radius"
                                        isSearchable={false} 
                                        isDisabled={!radiusAvailable}
                                        classNamePrefix="select-radius"
                                        onChange={event => {
                                            // minpriceval = event.value 
                                            props.setRadius(event.value)
                                        }}
                                    >
                                    </Select>
                                </div>
                                <div className="select-boxes order-xl-1">
                                    <CustomminpriceSelectbox attribute="price" value={min} defaultRefinement={{ min: min, max: max }} sales={props.sales} />
                                </div>
                                <div className="select-boxes order-xl-2">
                                    <CustommaxpriceSelectbox attribute="price" value={max} defaultRefinement={{ min: min, max: max }} sales={props.sales} />
                                </div>
                                <div className="select-boxes sel-bed order-xl-3">
                                    <CustombedroomSelectbox attribute="bedroom" value={bedrooms} defaultRefinement={{ min: bedrooms }} />
                                </div>
                                <div className="select-boxes sel-bulding order-xl-4">
                                    <CustomPropertyMenu attribute="building" value={building} defaultRefinement={building} />
                                </div>
                                <div className="select-boxes sel-type order-xl-5">
                                    <CustomOfficeMenu attribute="officeSlug" value={officeSlug} defaultRefinement={officeSlug} />
                                </div>
                            </div>
                        </Form>
                    </Col>
                </Row>
                <Row>
                    <Col className="col-12">
                        <div className="view-list">
                            <div className="menu-icons">
                                <span className={`menu-list p-0 ${!props.mapView ? 'active' : ''}`} onClick={() => props.setMapview(false)}>
                                    <i className="icon-list" />
                                    <span className="icon-text d-none d-md-block">List View</span>
                                </span>
                                <span className={`menu-list p-0 ${props.mapView ? 'active' : ''}`} onClick={() => props.setMapview(true)}>
                                    <i className="icon-map" />
                                    <span className="icon-text d-none d-md-block">Map View</span>
                                </span>
                            </div>

                            <div className="d-flex flex-row ais-checkbox">
                                <Form.Group className="mb-0" controlId="sold">
                                    <div className="form-check p-0">
                                        <Form.Label className="form-check-label mb-0 mr-lg-3">Include: </Form.Label>
                                    </div>
                                </Form.Group>
                                <Form.Group className="mb-0" controlId="sold">
                                    <Form.Check
                                        type="checkbox"
                                        label={props.sales ? "Sold" : "Let"}
                                        onChange={(e) => props.includeSold(e.target.checked)}
                                    />
                                </Form.Group>
                                <Form.Group className="mb-0 ml-lg-3 ml-1" controlId="under-offer">
                                    <Form.Check
                                        className="under-offer"
                                        type="checkbox"
                                        label="Under Offer"
                                        onChange={(e) => props.includeUnderOffer(e.target.checked)}
                                    />
                                </Form.Group>
                                {!props.mapView && <div className="drop-down box d-md-block d-none">
                                    <SortBy
                                        defaultRefinement={props.index_name}
                                        className="search-sory-by form-control"
                                        items={[
                                            { value: props.index_name + "_recent", label: "Recently added" },
                                            { value: props.index_name, label: "Highest Price" },
                                            { value: props.index_name + "_price_asc", label: "Lowest Price" },
                                        ]}
                                    />
                                </div>}
                            </div>
                        </div>
                    </Col>
                    {!props.mapView && <Col className="col-12 d-md-none d-block">
                        <div className="view-list pt-1 justify-content-end">
                            <div className="drop-down box ">
                                <SortBy
                                    defaultRefinement={props.index_name}
                                    className="search-sory-by form-control"
                                    items={[
                                        { value: props.index_name, label: "Highest Price" },
                                        { value: props.index_name + "_price_asc", label: "Lowest Price" },
                                        { value: props.index_name + "_recent", label: "Recently added" },
                                    ]}
                                />
                            </div>
                        </div>
                    </Col>}
                </Row>
            </Container>
        </section>
    )
};
export default React.memo(FilterPage)
